import React, { FC } from 'react';

export const ZendeskLayout: FC = ({ children }) => {
  return <div>
    {children}
  </div>;
};
